module.exports = __webpack_public_path__ + "static/accountability-5e68184ce9f5b4db8893950a5f738c58.jpg";